import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { InfoCard } from "../../subscription/ui/InfoCard";
import Styles from "../../../scss/subscriptions.module.scss";
import { createStyles, makeStyles } from "@material-ui/core";
import { useSignup } from "../state/SelfSignup";
import { useEffect } from "react";

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            margin: "2rem",
        },
        title: {
            fontSize: '1.15rem'
        }
    }));

export function UnavailableComponent() {
    const { t } = useTranslation();
    const { removeSnapshot } = useSignup();

    useEffect(() => {
        removeSnapshot();
        // eslint-disable-next-line
    }, [])

    const classes = useStyles();
    return <div className={classes.root}>
        <div className={classes.title}>
            {t("signup.completed.invalidCountryTitle")}
        </div>
        <div className={Styles.SubscriptionsContainer}>
            <InfoCard
                title={t("signup.completed.invalidCountryHelpTitle") as string}
                content={<Trans
                    i18nKey="signup.completed.invalidCountryHelper"
                    components={{ bold: <strong /> }}
                />}
            />
        </div>

    </div>
}